<template>
    <div class="w-full h-screen flex items-center justify-center bg-theme-card">
        <div class="w-full max-w-md text-center px-4">
            <span class="block text-9xl font-bold text-theme-primary mb-4"
                >404</span
            >
            <div class="mb-6 text-xl text-theme-muted">
                La página que buscas no existe 😵.
            </div>
            <router-link
                to="/"
                class="inline-block text-theme-primary hover:opacity-80 underline font-medium text-lg cursor-pointer transition-colors"
                aria-label="Ir a inicio"
            >
                Vuelve al inicio 🏠
            </router-link>
        </div>
    </div>
</template>

<script>
export default {
    name: "NotFound"
};
</script>
